import { Clear, Save } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Checkbox,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import NormalTable from "../../../../Component/NormalTable";
import * as Yup from "yup";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { color } from "../../../../StyleData/Config";
import ErrorProps from "../../../../Component/Errorprops";
import { toast } from "react-toastify";

const LabourBusinessCraft = ({
  taskData,
  handleCloseClick,
  type,
  dataDetail,
  woId,
  workcenterName,
  woDetail,
}) => {
  const [labourData, setLabourData] = useState([]);
  const [labourSelect, setLabourSelect] = useState([]);
  const [businessSelect, setBusinessSelect] = useState([]);
  const [businessData, setBusinessData] = useState([]);
  const [typeData, setTypeData] = useState("1");
  const [craftSelect, setCraftSelect] = useState([]);
  const [craftData, setCraftData] = useState([]);
  const [labourCompleteDetial, setlabourCompleteDetail] = useState([]);
  const [businessCompleteDetial, setbusinessCompleteDetail] = useState([]);
  const [craftCompleteDetail, setCraftCompleteDetail] = useState([]);
  const [planHours, setPlanHours] = useState("");
  const [businessQuantitiy, setBuQuantitiy] = useState(false);
  const [laborHide, setLabourHide] = useState(true);
  const [errorTime, setErrorTime] = useState("");
  const [quantity, setQuantity] = useState(
    laborHide || businessQuantitiy ? "1" : "",
  );
  const [workCenterOptions, setWorkCenterOptions] = useState([]);
  const [selectedWorkCenterIds, setSelectedWorkCenterIds] = useState(
    woDetail?.workCenterIdList || [],
  );
  const [labourLoading, setLabourLoading] = useState(false);

  const getData = useCallback(async () => {
    try {
      const wcResponse = await axiosPrivate.get(
        "/selectlist/getallworkcenters",
      );
      setWorkCenterOptions(
        (wcResponse.data || []).filter(
          (wc) => wc.value && String(wc.text).toLowerCase() !== "none",
        ),
      );
    } catch (e) {
      setWorkCenterOptions([]);
    }

    const wcIds = woDetail?.workCenterIdList || [];

    if (wcIds.length === 0) {
      console.warn("No workcenter IDs provided");
      return;
    }

    setLabourLoading(true);
    try {
      const labourLink = masterAPI["labourCraft"].getlaboursbyworkcenters;
      const labourResponse = await axiosPrivate.post(labourLink, wcIds);
      setLabourData(labourResponse.data.result || []);
    } catch (e) {
      setLabourData([]);
      console.log(e, "labourCraft by workcenter error");
    }

    // Fetch business craft data by workcenter IDs
    try {
      const businessLink = masterAPI["businessCraft"].getbusinessbyworkcenters;
      const businessResponse = await axiosPrivate.post(businessLink, {
        workCenterIdList: wcIds,
      });
      setBusinessData(businessResponse.data.result || []);
    } catch (e) {
      setBusinessData([]);
      console.log(e, "businessCraft by workcenter error");
    }
    setLabourLoading(false);

    // Fetch general craft data (keeping the original logic)
    try {
      const craftLink = masterAPI["crafts"].link;
      const craftResponse = await axiosPrivate.get(`${craftLink}`);
      console.log(craftResponse.data.result, "crafts");
      setCraftData(craftResponse.data.result || []);
    } catch (e) {
      setCraftData([]);
      console.log(e, "crafts error");
    }
  }, [woDetail]);

  useEffect(() => {
    getData();
  }, [getData]);

  const fetchLabourByWorkCenter = async (wcIds) => {
    if (!wcIds || wcIds.length === 0) return;
    setLabourLoading(true);
    try {
      const labourLink = masterAPI["labourCraft"].getlaboursbyworkcenters;
      const labourResponse = await axiosPrivate.post(labourLink, wcIds);
      setLabourData(labourResponse.data.result || []);
    } catch (e) {
      setLabourData([]);
    }
    try {
      const businessLink = masterAPI["businessCraft"].getbusinessbyworkcenters;
      const businessResponse = await axiosPrivate.post(businessLink, wcIds);
      setBusinessData(businessResponse.data.result || []);
    } catch (e) {
      setBusinessData([]);
    }
    setLabourLoading(false);
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({ cell }) => {
        const row = cell.row.original;
        return (
          <Checkbox
            checked={labourCompleteDetial.some(
              (ex) =>
                ex.labourId === row.labourId &&
                ex.workCenterId === row.workCenterId &&
                ex.craftId === row.craftId,
            )}
            onClick={() => {
              handleCheck(cell.row.original);
            }}
          />
        );
      },
    },
    {
      Header: "Labour Name",
      accessor: "labourName",
    },
    {
      Header: "Craft Name",
      accessor: "craftName",
    },
    {
      Header: "Work Center",
      accessor: "workCenterName",
    },
  ];

  const columnsBus = [
    {
      accessor: "id",
      Cell: ({ cell }) => {
        const row = cell.row.original;
        return (
          <Checkbox
            checked={businessCompleteDetial.some(
              (ex) =>
                ex.businessId === row.businessId &&
                ex.workCenterId === row.workCenterId,
            )}
            onClick={() => {
              handleBusCheck(cell.row.original);
            }}
          />
        );
      },
    },
    {
      Header: "Business Name",
      accessor: "businessName",
    },
    {
      Header: "Craft Name",
      accessor: "craftName",
    },
    {
      Header: "Work Center",
      accessor: "workCenterName",
    },
  ];

  const columnsCraft = [
    {
      accessor: "id",
      Cell: ({ cell }) => {
        return (
          <Checkbox
            checked={craftSelect.includes(cell.row.original.id)}
            onClick={() => {
              handleCraft(cell.row.original);
            }}
          />
        );
      },
    },
    {
      Header: "Craft Name",
      accessor: "craftName",
    },
  ];

  const listColumns = [
    {
      Header: "Task No",
      accessor: "taskNo",
    },
    {
      Header: "Task Name",
      accessor: "taskName",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Sequence No",
      accessor: "sequenceNo",
    },
    {
      Header: "Task Duration (HR)",
      accessor: "taskDuration",
    },
  ];

  const comColumns = [
    {
      Header: "Task No",
      accessor: "taskNo",
    },
    {
      Header: "Task Name",
      accessor: "taskName",
    },
  ];

  const handleCheck = (value) => {
    if (labourSelect.includes(value.id)) {
      const removeData = labourSelect.filter((l) => l !== value.id);
      const removeCompleteData = labourCompleteDetial.filter(
        (lab) =>
          lab.labourId !== value.labourId &&
          lab.workCenterId !== value.workCenterId &&
          lab.craftId !== value.craftId,
      );
      setLabourSelect(removeData);
      setlabourCompleteDetail(removeCompleteData);
    } else {
      setLabourSelect([...labourSelect, value.id]);
      setlabourCompleteDetail([...labourCompleteDetial, value]);
    }
  };

  const handleBusCheck = (value) => {
    if (businessSelect.includes(value.id)) {
      const removeData = businessSelect.filter((l) => l !== value.id);
      const removeCompleteData = businessCompleteDetial.filter(
        (bus) =>
          bus.businessId !== value.businessId &&
          bus.workCenterId !== value.workCenterId &&
          bus.craftId !== value.craftId,
      );
      setbusinessCompleteDetail(removeCompleteData);
      setBusinessSelect(removeData);
    } else {
      setBusinessSelect([...businessSelect, value.id]);
      setbusinessCompleteDetail([...businessCompleteDetial, value]);
    }
  };

  const handleCraft = (value) => {
    if (craftSelect.includes(value.id)) {
      const removeData = craftSelect.filter((l) => l !== value.id);
      const removeCompleteData = craftCompleteDetail.filter(
        (cra) => cra.id !== value.id,
      );
      setCraftSelect(removeData);
      setCraftCompleteDetail(removeCompleteData);
    } else {
      setCraftSelect([...craftSelect, value.id]);
      setCraftCompleteDetail([...craftCompleteDetail, value]);
    }
  };

  const updateWorkOrderIfNeeded = async () => {
    const original = woDetail?.workCenterIdList || [];
    const changed =
      selectedWorkCenterIds.length !== original.length ||
      selectedWorkCenterIds.some((id) => !original.includes(id));
    if (changed && woDetail) {
      const updateLink = masterAPI["workOrder"].updateWorkcenter;
      await axiosPrivate.put(`${updateLink}/${woId}`, selectedWorkCenterIds);
    }
  };

  const handleLabourSubmit = async () => {
    console.log(labourSelect, taskData);

    if (labourCompleteDetial.length === 0) {
      toast.error("Please select labour");
    } else {
      const wotlink = masterAPI["workOrderTaskLabour"].bulkinsert;
      const jptlink = masterAPI["jobPlanTaskLabour"].bulkinsert;
      let decimalPlanHours =
        Number(planHours.split(":")[0]) + Number(planHours.split(":")[1]) / 60;

      if (type === "wot" || type === "completion") {
        const wo = [];

        for (let i = 0; i < taskData.length; i++) {
          for (let j = 0; j < labourCompleteDetial.length; j++) {
            console.log(labourCompleteDetial[i]);
            const wotData = {
              workOrderTaskId: taskData[i],
              labourId: labourCompleteDetial[j].labourId,
              workOrderId: woId,
              craftId: labourCompleteDetial[j].craftId,
              workCenterId: labourCompleteDetial[j].workCenterId || null,
              quantity: quantity,
              plannedHours: decimalPlanHours,
              rate: labourCompleteDetial[j].rateForRegularHors,
              cost:
                labourCompleteDetial[j].rateForRegularHors * decimalPlanHours,
              plannedCost:
                labourCompleteDetial[j].rateForRegularHors * decimalPlanHours,
              isPlannedLabour: true,
            };
            console.log(wotData, i, j);
            wo.push(wotData);
          }
        }
        console.log("test", wo);

        try {
          await updateWorkOrderIfNeeded();
          const response = await axiosPrivate.post(`${wotlink}`, wo);
          console.log(response);
          // toast.success("Labour data saved successfully");
          // handleCloseClick();
        } catch (e) {
          console.log(e, "createwotaskLabour");
          // toast.error("Failed to save labour data");
        }
      } else {
        const jplan = [];
        for (let i = 0; i < taskData.length; i++) {
          for (let j = 0; j < labourCompleteDetial.length; j++) {
            const jptData = {
              jobPlanTaskId: taskData[i],
              labourId: labourCompleteDetial[j].labourId,
              craftId: labourCompleteDetial[j].craftId,
              quantity: quantity,
              workOrderId: woId,
              plannedHours: decimalPlanHours,
              rate: labourCompleteDetial[j].rateForRegularHors,
              cost:
                labourCompleteDetial[j].rateForRegularHors * decimalPlanHours,
              plannedCost:
                labourCompleteDetial[j].rateForRegularHors * decimalPlanHours,
              isPlannedLabour: true,
            };
            console.log(jptData, i, j);
            jplan.push(jptData);
          }
        }
        console.log(jplan);

        try {
          await updateWorkOrderIfNeeded();
          const response = await axiosPrivate.post(`${jptlink}`, jplan);
          console.log(response, "jpt");
          // toast.success("Labour data saved successfully");
          // handleCloseClick();
        } catch (e) {
          console.log(e, "createjptaskLabour");
          // toast.error("Failed to save labour data");
        }
      }
    }
  };

  const handleBusSubmit = async () => {
    console.log(businessSelect, taskData);
    if (businessCompleteDetial.length === 0) {
      toast.error("Please select business");
    } else {
      let decimalPlanHours =
        Number(planHours.split(":")[0]) + Number(planHours.split(":")[1]) / 60;

      const wotlink = masterAPI["workOrderTaskLabour"].bulkinsert;
      const jptlink = masterAPI["jobPlanTaskLabour"].bulkinsert;

      if (type === "wot") {
        const busData = [];
        for (let i = 0; i < taskData.length; i++) {
          for (let j = 0; j < businessCompleteDetial.length; j++) {
            const businesData = {
              workOrderTaskId: taskData[i],
              businessId: businessCompleteDetial[j].businessId,
              craftId: businessCompleteDetial[j].craftId,
              workCenterId: businessCompleteDetial[j].workCenterId || null,
              quantity: quantity,
              workOrderId: woId,
              plannedHours: decimalPlanHours,
              rate: businessCompleteDetial[j].rateForRegularHors,
              cost:
                businessCompleteDetial[j].rateForRegularHors * decimalPlanHours,
              isPlannedLabour: true,
            };
            console.log(businesData, i, j);
            busData.push(businesData);
          }
        }

        try {
          await updateWorkOrderIfNeeded();
          const response = await axiosPrivate.post(`${wotlink}`, busData);
          console.log(response);
          // toast.success("Business data saved successfully");
          // handleCloseClick();
        } catch (e) {
          console.log(e, "createwotaskLabour");
          // toast.error("Failed to save business data");
        }
      } else {
        console.log(businessCompleteDetial);
        const jpBusData = [];
        for (let i = 0; i < taskData.length; i++) {
          for (let j = 0; j < businessCompleteDetial.length; j++) {
            const jptData = {
              jobPlanTaskId: taskData[i],
              businessId: businessCompleteDetial[j].businessId,
              craftId: businessCompleteDetial[j].craftId,
              quantity: quantity,
              workOrderId: woId,
              plannedHours: decimalPlanHours,
              rate: businessCompleteDetial[j].rateForRegularHors,
              cost:
                businessCompleteDetial[j].rateForRegularHors * decimalPlanHours,
              isPlannedLabour: true,
            };
            jpBusData.push(jptData);
          }
        }
        console.log(jpBusData);

        try {
          await updateWorkOrderIfNeeded();
          const response = await axiosPrivate.post(`${jptlink}`, jpBusData);
          console.log(response, "jpt");
          // toast.success("Business data saved successfully");
          // handleCloseClick();
        } catch (e) {
          console.log(e, "createjptaskLabour");
          // toast.error("Failed to save business data");
        }
      }
    }
  };

  const handleCraftSubmit = async () => {
    console.log(craftSelect, taskData);
    if (craftCompleteDetail.length === 0) {
      toast.error("Please select craft");
    } else {
      let decimalPlanHours =
        Number(planHours.split(":")[0]) + Number(planHours.split(":")[1]) / 60;
      const wotlink = masterAPI["workOrderTaskLabour"].bulkinsert;
      const jptlink = masterAPI["jobPlanTaskLabour"].bulkinsert;

      if (type === "wot") {
        console.log(craftCompleteDetail);
        const wotCraftData = [];
        for (let i = 0; i < taskData.length; i++) {
          for (let j = 0; j < craftCompleteDetail.length; j++) {
            const wotData = {
              workOrderTaskId: taskData[i],
              craftId: craftCompleteDetail[j].id,
              rate: craftCompleteDetail[j].rateForRegularHors,
              cost:
                craftCompleteDetail[j].rateForRegularHors * decimalPlanHours,
              quantity: quantity,
              workOrderId: woId,
              plannedHours: decimalPlanHours,
              isPlannedLabour: true,
            };
            console.log(wotData, i, j);
            wotCraftData.push(wotData);
          }
        }
        console.log(wotCraftData);

        try {
          await updateWorkOrderIfNeeded();
          const response = await axiosPrivate.post(`${wotlink}`, wotCraftData);
          console.log(response);
          // toast.success("Craft data saved successfully");
          // handleCloseClick();
        } catch (e) {
          console.log(e, "createwotaskLabour");
          // toast.error("Failed to save craft data");
        }
      } else {
        const jpCraftData = [];
        for (let i = 0; i < taskData.length; i++) {
          for (let j = 0; j < craftSelect.length; j++) {
            const jptData = {
              jobPlanTaskId: taskData[i],
              craftId: craftCompleteDetail[j].id,
              rate: craftCompleteDetail[j].rateForRegularHors,
              cost:
                craftCompleteDetail[j].rateForRegularHors * decimalPlanHours,
              quantity: quantity,
              workOrderId: woId,
              plannedHours: decimalPlanHours,
              isPlannedLabour: true,
            };
            console.log(jptData, i, j);
            jpCraftData.push(jptData);
          }
        }
        console.log(jpCraftData);

        try {
          await updateWorkOrderIfNeeded();
          const response = await axiosPrivate.post(`${jptlink}`, jpCraftData);
          console.log(response, "jpt");
          // toast.success("Craft data saved successfully");
          // handleCloseClick();
        } catch (e) {
          console.log(e, "createjptaskLabour");
          // toast.error("Failed to save craft data");
        }
      }
    }
  };

  const handleType = (e) => {
    setTypeData(e.target.value);
    setBuQuantitiy(e.target.value === "2");
    setLabourHide(e.target.value === "1");
  };

  const timeSchema = Yup.object({
    planHours: Yup.string()
      .required("Time is required")
      .matches(/^\d+:[0-5]\d$/, "Format must be HH:MM and minutes 00-59"),
  });

  const validatePlanHours = (value) => {
    try {
      timeSchema.validateSync({ planHours: value }, { abortEarly: false });
      setErrorTime("");
    } catch (err) {
      setErrorTime(err.errors[0]);
    }
  };

  const handleSubmit = () => {
    try {
      timeSchema.validateSync({ planHours }, { abortEarly: false });

      if (typeData === "1") {
        handleLabourSubmit();
      } else if (typeData === "2") {
        handleBusSubmit();
      } else {
        handleCraftSubmit();
      }
      setErrorTime("");
    } catch (err) {
      setErrorTime(err.errors[0]);
    }
  };

  return (
    <Grid container sx={{ p: 1 }} spacing={"1.5rem"}>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: color.masterDialogTitleColor,
              fontSize: "1.1rem",
              fontWeight: 500,
            }}
          >
            Select Task
          </Typography>
          <Box>
            <IconButton
              onClick={() => {
                handleCloseClick();
              }}
            >
              <Clear />
            </IconButton>
          </Box>
        </Box>
        <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} />
      </Grid>

      <Grid item container xs={12}>
        <NormalTable
          data={dataDetail}
          columns={type === "completion" ? comColumns : listColumns}
        />
      </Grid>

      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: color.masterDialogTitleColor,
              fontSize: "1.1rem",
              fontWeight: 500,
            }}
          >
            Labour
          </Typography>
          <Box>
            <IconButton
              onClick={() => {
                handleSubmit();
              }}
            >
              <Save sx={{ color: "#2362B4" }} />
            </IconButton>
          </Box>
        </Box>
        <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} />
      </Grid>

      <Grid container item xs={12} spacing={"1.5rem"}>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontWeight: color.labelFontWeight,
              mb: color.labelmb,
              fontSize: color.labelFont,
            }}
          >
            Work Center
          </Typography>
          <Autocomplete
            multiple
            fullWidth
            options={workCenterOptions}
            getOptionLabel={(option) => option.text || ""}
            isOptionEqualToValue={(option, val) => option.value === val.value}
            value={workCenterOptions.filter((wc) =>
              selectedWorkCenterIds.includes(wc.value),
            )}
            onChange={(_, newValue) => {
              const ids = newValue.map((v) => v.value);
              const isRemoval = ids.length < selectedWorkCenterIds.length;
              if (isRemoval && labourSelect.length > 0) {
                toast.warning(
                  "You have unsaved labour selections. Please save before changing the work center.",
                );
              }
              setSelectedWorkCenterIds(ids);
              fetchLabourByWorkCenter(ids);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                placeholder="Select Work Center"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography
            sx={{
              fontWeight: color.labelFontWeight,
              mb: color.labelmb,
              fontSize: color.labelFont,
            }}
          >
            Select
          </Typography>
          <Select
            value={typeData}
            onChange={handleType}
            size="small"
            fullWidth
            readOnly={type === "completion"}
          >
            <MenuItem value="1">Labour</MenuItem>
            <MenuItem value="2">Business</MenuItem>
            <MenuItem value="3">Craft</MenuItem>
          </Select>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
          sx={{ display: laborHide ? "none" : "block" }}
        >
          <Typography
            sx={{
              fontWeight: color.labelFontWeight,
              mb: color.labelmb,
              fontSize: color.labelFont,
            }}
          >
            Quantity
          </Typography>
          <TextField
            name="qauntity"
            size="small"
            fullWidth
            placeholder="Enter Quantity"
            value={quantity}
            onChange={(e) => {
              setQuantity(e.target.value);
            }}
          />
        </Grid>

        <Grid item xs={12} md={laborHide ? 6 : 5}>
          <Typography
            sx={{
              fontWeight: color.labelFontWeight,
              mb: color.labelmb,
              fontSize: color.labelFont,
            }}
          >
            Planned Hours (HH:MM)
          </Typography>
          <TextField
            name="plannedHours"
            size="small"
            fullWidth
            placeholder="HH:MM"
            value={planHours}
            onChange={(e) => {
              setPlanHours(e.target.value);
              validatePlanHours(e.target.value);
            }}
            onBlur={(e) => {
              validatePlanHours(e.target.value);
            }}
          />
          <ErrorProps>{errorTime}</ErrorProps>
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ display: typeData === "1" ? "grid" : "none" }}>
        {labourLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          <NormalTable data={labourData} columns={columns} filt={true} />
        )}
      </Grid>

      <Grid item xs={12} sx={{ display: typeData === "2" ? "grid" : "none" }}>
        <NormalTable data={businessData} columns={columnsBus} />
      </Grid>

      <Grid item xs={12} sx={{ display: typeData === "3" ? "grid" : "none" }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          General Crafts
        </Typography>
        <NormalTable data={craftData} columns={columnsCraft} />
      </Grid>
    </Grid>
  );
};

export default LabourBusinessCraft;
